import { rmBuddiesInitialState } from "./initital-state";
import {
  SET_UPDATED_PROFILE_SELECTED_BUDDY,
  SET_RM_BUDDIES_WAREHOUSE_ID,
  SET_RM_BUDDIES_SEARCH_QUERY,
  SET_VISIBLE_RM_BUDDIES,
  SET_RM_BUDDIES_FILTER_BUDDY_BLOCK,
  SET_UPLOAD_RM_BUDDIES_STATUS,
  SET_RM_BUDDIES_SEARCH_RESULTS,
  SET_RM_BUDDIES,
  SET_BUDDY_BLOCKS_LIST,
  SET_RM_BUDDIES_WAREHOUSE_LIST,
  SET_UNALLOCATED_RM_BUDDY_TASKS,
  SET_RM_BUDDY_TASKS,
  SET_TASKS_TYPE_FILTER,
  SET_TASKS_DUE_DATE_FILTER,
  SET_RM_BUDDY_TASK,
  SET_SUGGESTED_TRANSFER_BUDDIES,
  SET_SELECTED_RM_BUDDY,
  SET_DELAYED_RM_BUDDY_TASKS,
  SET_SEARCH_TASK_RESULTS,
  SET_LEAVES,
  SET_PENDING_TASKS_SELECTED_RMBUDDY,
  SET_TRANSFER_WARNING,
  SET_TASKS_STATUS_TAG_FILTER
} from "./actions";

const applyFrontendFilters = (state, e) => {
  return state.tasksTypeFilter
    ? state.tasksTypeFilter.indexOf(e.taskType) !== -1
    : true && state.tasksStatusTagFilter
    ? e.statusTag && state.tasksStatusTagFilter.indexOf(e.statusTag) !== -1
    : true;
};

export const rmBuddiesReducer = (state = rmBuddiesInitialState, action) => {
  switch (action.type) {
    case SET_UPDATED_PROFILE_SELECTED_BUDDY:
      return {
        ...state,
        rmBuddiesList: state.rmBuddiesList.map(e => {
          if (e._id === state.selectedRmBuddyId) {
            return {
              ...e,
              phone_num: action.payload.mobileNumber,
              name: action.payload.name,
              email: action.payload.email
            };
          }
          return e;
        }),
        visibleRmBuddiesList: state.visibleRmBuddiesList.map(e => {
          if (e._id === state.selectedRmBuddyId) {
            return {
              ...e,
              phone_num: action.payload.mobileNumber,
              name: action.payload.name,
              email: action.payload.email
            };
          }
          return e;
        })
      };
    case SET_RM_BUDDIES_WAREHOUSE_LIST:
      return {
        ...state,
        warehouseList: action.payload
      };
    case SET_UPLOAD_RM_BUDDIES_STATUS:
      return {
        ...state,
        rmBuddiesUploaded: action.payload
      };
    case SET_RM_BUDDIES_WAREHOUSE_ID:
      if (!action.payload) {
        return {
          ...rmBuddiesInitialState
        };
      }
      return {
        ...rmBuddiesInitialState,
        currentWarehouseId: action.payload
      };
    case SET_RM_BUDDIES_FILTER_BUDDY_BLOCK:
      return {
        ...state,
        rmBuddiesFilter: {
          ...state.rmBuddiesFilter,
          buddyBlockId: action.payload
        }
      };

    case SET_RM_BUDDIES_SEARCH_QUERY:
      return {
        ...state,
        rmBuddiesFilter: {
          ...state.rmBuddiesFilter,
          searchQuery: action.payload
        }
      };
    case SET_RM_BUDDIES_SEARCH_RESULTS:
      return {
        ...state,
        searchedRmBuddiesResults: action.payload
      };
    case SET_RM_BUDDIES:
      return {
        ...state,
        rmBuddiesList: action.payload,
        visibleRmBuddiesList: action.payload
      };
    case SET_VISIBLE_RM_BUDDIES:
      return {
        ...state,
        visibleRmBuddiesList: action.payload
      };
    case SET_BUDDY_BLOCKS_LIST:
      return {
        ...state,
        buddyBlocksList: action.payload
      };
    case SET_TRANSFER_WARNING:
      return {
        ...state,
        transferWarnings: action.payload
      };
    case SET_RM_BUDDY_TASKS:
      return {
        ...state,
        rmBuddyTasks: action.payload,
        taskDetails: null,
        visibleRmBuddyTasks: action.payload.filter(e =>
          applyFrontendFilters(state, e)
        )
      };
    case SET_UNALLOCATED_RM_BUDDY_TASKS:
      return {
        ...state,
        unallocatedRmBuddyTasks: action.payload,
        taskDetails: null,
        visibleUnallocatedRmBuddyTasks: action.payload.filter(e =>
          applyFrontendFilters(state, e)
        )
      };
    case SET_DELAYED_RM_BUDDY_TASKS:
      return {
        ...state,
        delayedRmBuddyTasks: action.payload,
        taskDetails: null,
        visibleDelayedRmBuddyTasks: action.payload.filter(e =>
          applyFrontendFilters(state, e)
        )
      };
    case SET_TASKS_TYPE_FILTER:
      if (!action.payload || action.payload.length === 0) {
        return {
          ...state,
          tasksTypeFilter: null,
          visibleRmBuddyTasks: state.rmBuddyTasks,
          visibleUnallocatedRmBuddyTasks: state.unallocatedRmBuddyTasks
        };
      }
      const newFilter = action.payload;
      return {
        ...state,
        tasksTypeFilter: newFilter,
        visibleRmBuddyTasks: state.rmBuddyTasks.filter(
          e => newFilter.indexOf(e.taskType) !== -1
        ),
        visibleUnallocatedRmBuddyTasks: state.unallocatedRmBuddyTasks.filter(
          e => newFilter.indexOf(e.taskType) !== -1
        )
      };
    case SET_TASKS_STATUS_TAG_FILTER:
      if (!action.payload || action.payload.length === 0) {
        return {
          ...state,
          tasksStatusTagFilter: null,
          visibleRmBuddyTasks: state.rmBuddyTasks,
          visibleUnallocatedRmBuddyTasks: state.unallocatedRmBuddyTasks
        };
      }
      const newStatusTagFilter = action.payload;
      return {
        ...state,
        tasksStatusTagFilter: newStatusTagFilter,
        visibleRmBuddyTasks: state.rmBuddyTasks.filter(
          e => e.statusTag && newStatusTagFilter.indexOf(e.statusTag) !== -1
        ),
        visibleUnallocatedRmBuddyTasks: state.unallocatedRmBuddyTasks.filter(
          e => e.statusTag && newStatusTagFilter.indexOf(e.statusTag) !== -1
        )
      };
    case SET_TASKS_DUE_DATE_FILTER:
      return {
        ...state,
        tasksDueDateFilter: action.payload
      };
    case SET_RM_BUDDY_TASK:
      return {
        ...state,
        taskDetails: action.payload
      };
    case SET_SUGGESTED_TRANSFER_BUDDIES:
      return {
        ...state,
        suggestedTransferBuddies: action.payload
      };
    case SET_SELECTED_RM_BUDDY:
      return {
        ...state,
        selectedRmBuddyId: action.payload,
        rmBuddyTasks: null,
        pendingTasksOfSelectedRMBuddy: null,
        selectedRmBuddyLeaves: null,
        visibleRmBuddyTasks: null,
        delayedRmBuddyTasks: null,
        unallocatedRmBuddyTasks: null,
        taskDetails: null,
        visibleDelayedRmBuddyTasks: null,
        visibleUnallocatedRmBuddyTasks: null
      };
    case SET_SEARCH_TASK_RESULTS:
      return {
        ...state,
        taskSearchResults: action.payload
      };
    case SET_LEAVES:
      return {
        ...state,
        selectedRmBuddyLeaves: action.payload
      };
    case SET_PENDING_TASKS_SELECTED_RMBUDDY:
      return {
        ...state,
        pendingTasksOfSelectedRMBuddy: action.payload
      };
    default:
      return state;
  }
};
